module.exports = __webpack_public_path__ + "img/7.c3286ed6.jpg";